import { useTranslation } from "react-i18next";
import { Trash2, X } from "lucide-react";
import { useTryOnPhotos } from "../hooks/use-try-on-photos";

/**
 * Try-on fotoğrafını silme onayı dialog'u (zero props)
 */
export const TryOnPhotoDeleteDialog: React.FC = () => {
  const { t } = useTranslation();
  const { deletingPhoto, confirmDelete, closeDeleteDialog, isDeleting } =
    useTryOnPhotos();

  if (!deletingPhoto) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/50"
        onClick={closeDeleteDialog}
      />

      <div className="relative bg-white dark:bg-gray-800 rounded-[20px] shadow-xl max-w-sm w-full mx-4 p-6 flex flex-col gap-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-red-50 dark:bg-red-900/25 text-red-600 dark:text-red-400">
              <Trash2 className="h-4.5 w-4.5" />
            </div>
            <h2 className="text-lg font-semibold text-text-primary dark:text-gray-100">
              {t("settings.profile.tryOn.deleteTitle")}
            </h2>
          </div>
          <button
            type="button"
            onClick={closeDeleteDialog}
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-text-primary dark:text-gray-100" />
          </button>
        </div>

        <p className="text-sm text-text-tertiary dark:text-gray-400 leading-5">
          {t("settings.profile.tryOn.deleteDescription", {
            name: deletingPhoto.name,
          })}
        </p>

        <div className="flex gap-3 justify-end">
          <button
            type="button"
            onClick={closeDeleteDialog}
            className="px-3.5 py-2.5 rounded-lg bg-white dark:bg-gray-700 border border-border-primary dark:border-gray-600 text-text-secondary dark:text-gray-300 text-sm font-semibold hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors shadow-sm"
          >
            {t("settings.profile.cancel")}
          </button>
          <button
            type="button"
            onClick={() => void confirmDelete()}
            disabled={isDeleting}
            className="px-4 py-2.5 rounded-lg bg-red-600 hover:bg-red-700 text-white text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isDeleting
              ? t("settings.profile.tryOn.deleting")
              : t("settings.profile.tryOn.deleteConfirm")}
          </button>
        </div>
      </div>
    </div>
  );
};
